import { TEventData } from "../@types/data/event"
import { TShoppingTicket } from "../@types/data/ticket"
import { DEFAULT_EVENT_END_DATE_YEAR } from "../consts/defaultEndDate"
import { getDateString } from "../tb/date"
import { formatMoney } from "../tb/formatMoney"
import { getFormattedRegister } from "../tb/formatters/getFormattedRegister"
import { monthsRelations } from "../tb/getDatePeriod"
import { getProductTaxes } from "../tb/taxes"
import { paymentTypeLabel } from "../tb/paymentTypeLabel"
import { buildTicketInfoRows } from "./defaultTicketInfo"

export const reportTitle = [
  {
    image: "",
    margin: [0, 28, 17, 0],
    width: 170,
    style: { alignment: "right" },
  },
]

export const footer = (event: TEventData) => [
  {
    text: [
      {
        text: `Razão Social: `,
        fontSize: 10,
        style: "companyFooterTag",
      },
      {
        text: `${event.corporateName}          `,
        fontSize: 10,
        style: "companyFooter",
      },
      {
        text: `CNPJ: `,
        fontSize: 10,
        style: "companyFooterTag",
      },
      {
        text: `${getFormattedRegister(event.CNPJ)}`,
        fontSize: 10,
        style: "companyFooter",
      },
    ],
    margin: [38, 0, 10, -12],
  },
  {
    text: `${new Date().toLocaleDateString()} - ${new Date().toLocaleTimeString()}`,
    fontSize: 10,
    style: "dateFooter",
    margin: [0, 0, 38, 0],
    width: ["*"],
  },
]

const formatdM = (date: string | number | Date) => {
  let str = ""

  const dt = new Date(date)

  const d = String(dt.getUTCDate()).padStart(2, "0")
  const m = dt.getUTCMonth()

  str += `${d} de ${monthsRelations[m]}`

  return str
}

const formatHour = (str?: string) => {
  if (!str) return "Dia todo"
  else {
    const _d = new Date()

    const dateStr = `${_d.getFullYear()}-${String(_d.getMonth() + 1).padStart(2, "0")}-${String(_d.getDate()).padStart(2, "0")}T${str}.000Z`

    const formattedHour = new Date(dateStr).toLocaleTimeString()

    return formattedHour.slice(0, 5)
  }
}

const ticketData = (
  event: TEventData,
  ticket: TShoppingTicket & {
    user_name?: string
    tax_value?: number
    TRN?: string
    payment_type?: string
    combo_id?: string | null
    combo_name?: string | null
  },
  ticketsLength: number,
  newPage: boolean,
) => {

  const isFromCombo = Boolean(
    ticket.combo_id && ticket.combo_id !== "" && 
    ticket.combo_name && ticket.combo_name !== ""
  )
  const { platformTax, additionalTax } = getProductTaxes(event, ticket)

  let data: any[] = []
  let body = []

  try {
    const hours = formatHour(event.time_ini)

    const hasValidEndDate = Boolean(event.date_end && event.date_end !== "" 
      && new Date(event.date_end).getTime() >= new Date(event.date_ini).getTime())
      && new Date(event.date_end).getFullYear() < DEFAULT_EVENT_END_DATE_YEAR

    const eventDateText =
      event.date_end === event.date_ini || !hasValidEndDate
        ? formatdM(event.date_ini)
        : `${formatdM(event.date_ini)} até ${formatdM(event.date_end)}`

    const eventInfo = {
      pageBreak: newPage ? "before" : undefined,
      style: "eventTable",
      table: {
        body: [
          // event
          [{ text: event.name, bold: true }],
          [
            {
              text: `Data do evento: ${eventDateText}`,
            },
          ],
          [{ text: `Início do evento: ${hours}` }],
          [{ text: `Local: ${event.local}. ${event.city}, ${event?.uf}` }],
        ],
        widths: ["*"],
      },
      layout: {
        hLineColor: function (i: number, node: any) {
          return "#dedede"
        },
        vLineColor: function (i: number, node: any) {
          return "#dedede"
        },
        hLineWidth: function (i: number, node: any) {
          return i === 0 || i === node.table.body.length ? 1 : 0
        },
        vLineWidth: function (i: number, node: any) {
          return i === 0 || i === node.table.widths.length ? 1 : 0
        },
        hLineStyle: function (i: number, node: any) {
          if (i === 0 || i === node.table.body.length) {
            return null
          }
          return { dash: { length: 10, space: 4 } }
        },
        vLineStyle: function (i: number, node: any) {
          if (i === 0 || i === node.table.widths.length) {
            return null
          }
          return { dash: { length: 4 } }
        },
        paddingLeft: function () {
          return 10
        },
        paddingRight: function () {
          return 10
        },
        paddingTop: function (i: number) {
          return i === 0 ? 10 : 2
        },
        paddingBottom: function (i: number) {
          return i === ticketsLength - 1 ? 10 : 2
        },
      },
    }

    // event
    body.push(eventInfo)

    // ticket

    let tableBody: any[] = [
      [{ text: `Ingresso${isFromCombo ? ` - Combo: ${ticket.combo_name}` : ""}`, bold: true, style: "tableTitle" }],
      [
        {
          text: `Comprado dia ${getDateString("full", ticket.date)}`,
          style: "purchaseDate",
        },
      ],
      ...(ticket.buyer_name
        ? [
            [
              {
                text: `Comprado por ${ticket.buyer_name}`,
                style: "purchaseDate",
              },
            ],
          ]
        : []),
      [
        {
          text:
            ticket.is_mesa || !ticket.batch_name
              ? ticket.name
              : `${ticket.name} - ${ticket.batch_name}`,
          style: "itemNameAndBatch"
        },
      ],
      ...(!isFromCombo ? [
        [
          {
            text: `PREÇO: ${formatMoney(
              ticket.price_unit * ticket.quantity,
              true,
            )}`,
          },
        ],
        ...(event.eCommerce.chargeClient || additionalTax > 0
          ? [
              [
                {
                  text: `TAXA: ${formatMoney(platformTax + additionalTax, true)}`,
                },
              ],
            ]
          : []),
      ] : []),
      ...(paymentTypeLabel(ticket.payment_type)
        ? [
            [
              {
                text: `FORMA DE PAGAMENTO: ${paymentTypeLabel(ticket.payment_type)}`,
              },
            ],
          ]
        : []),
    ]

    // nominal
    if (Boolean(event.nominal)) {
      // @ts-ignore
      const ticketUserName = ticket.user ?? ticket.ticket_name ?? null

      if (ticketUserName) {
        tableBody.push([
          { text: "Participante", bold: true, margin: [0, 16, 0, 0] },
        ])
        tableBody.push([
          { text: ticketUserName ?? "Não especificado", margin: [0, 0, 0, 16] },
        ])
      }
    }

    tableBody.push([
      {
        qr: `${ticket.qr_data}`,
        style: "qrcode",
        margin: [0, Boolean(event.nominal) ? 0 : 16, 0, 0],
      },
    ]) // ticket.qr_data only
    tableBody.push([
      {
        text: ticket.qr_label,
        style: "qrcodetext",
      },
    ]) // ticket.qr_data only

    tableBody.push([
      { text: `Referência: ${ticket.TRN}` }
    ])

    body.push({
      style: "eventTable",
      table: {
        body: tableBody,
        widths: ["*"],
      },
      layout: {
        hLineColor: function (i: number, node: any) {
          return "#dedede"
        },
        vLineColor: function (i: number, node: any) {
          return "#dedede"
        },
        hLineWidth: function (i: number, node: any) {
          return i === 0 || i === node.table.body.length ? 1 : 0
        },
        vLineWidth: function (i: number, node: any) {
          return i === 0 || i === node.table.widths.length ? 1 : 0
        },
        hLineStyle: function (i: number, node: any) {
          if (i === 0 || i === node.table.body.length) {
            return null
          }
          return { dash: { length: 10, space: 4 } }
        },
        vLineStyle: function (i: number, node: any) {
          if (i === 0 || i === node.table.widths.length) {
            return null
          }
          return { dash: { length: 4 } }
        },
        paddingLeft: function (i: number) {
          return i === 0 ? 10 : 0
        },
        paddingRight: function () {
          return 10
        },
        paddingTop: function (i: number) {
          return i === 0 ? 5 : i === 1 ? 10 : 2
        },
        paddingBottom: function (i: number) {
          return i === 0 ? 5 : 2 // and last item
        },
      },
    })

    // info
    body.push({
      style: "eventTable",
      table: {
        body: [
          // event
          [{ text: "INFORMAÇÕES IMPORTANTES", bold: true }],
          [{ text: "", style: "infoAnswer" }],
          ...buildTicketInfoRows(event.ticket_info),
        ],
        widths: ["*"],
      },
      layout: {
        hLineColor: function (i: number, node: any) {
          return "#dedede"
        },
        vLineColor: function (i: number, node: any) {
          return "#dedede"
        },
        hLineWidth: function (i: number, node: any) {
          return i === 0 || i === node.table.body.length ? 1 : 0
        },
        vLineWidth: function (i: number, node: any) {
          return i === 0 || i === node.table.widths.length ? 1 : 0
        },
        hLineStyle: function (i: number, node: any) {
          if (i === 0 || i === node.table.body.length) {
            return null
          }
          return { dash: { length: 10, space: 4 } }
        },
        vLineStyle: function (i: number, node: any) {
          if (i === 0 || i === node.table.widths.length) {
            return null
          }
          return { dash: { length: 4 } }
        },
        paddingLeft: function () {
          return 10
        },
        paddingRight: function () {
          return 10
        },
        paddingTop: function (i: number) {
          return i === 0 ? 10 : 2
        },
        paddingBottom: function (i: number, node: any) {
          return i === node.table.body.length - 1 ? 10 : 2
        },
      },
    })

    data = body
  } catch (error) {}

  return data
}

export const content = (event: TEventData, tickets: TShoppingTicket[]) => {
  let data: any[] = []

  // Event content
  data = [
    ...data,
    tickets.map((t, i) => ticketData(event, t, tickets.length, i > 0)),
  ]

  return data
}
